module.exports = __webpack_public_path__ + "img/E1.c37bc3fe.png";